module.exports = __webpack_public_path__ + "6f09592d0ff5e9a26c4d331ce71c665d.svg";